<template>
  <v-layout wrap>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#68D389"
      size="128"
      is-full-screen
    />
    <v-flex xs12 px-5 pb-5 align-self-center>
      <ServerError v-if="ServerError" />
      <v-layout wrap justify-start>
        <v-flex px-4 xs12 pt-3>
          <h2 style="poppins-bold">Blog</h2>
        </v-flex>
        <v-flex xs12 sm12 md6 xl4 v-for="(item, i) in result" :key="i" pa-3>
          <v-card tile :style="$vuetify.breakpoint.name == 'xs'
                    ? 'height: 450px'
                    : (style = 'height: 200px')"
           >
            <v-layout wrap justify-start pb-2>
              <v-flex xs12 sm4 md4>
                <v-img 
                  v-if="item.image"
                  :src="mediaURL + item.image"
                  height="200px"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color=" #FDAC53"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
                <v-img
                  v-else
                  src="../../assets/images/no-image.png"
                  height="200px"
                />
              </v-flex>
              <v-flex pl-3 xs8 sm8 md8 :style="{ height: '0px' }">
                <v-layout wrap>
                  <v-flex xs12>
                    <router-link class="routerlink" :to="'/Blog2/' + item._id">
                  <span style="cursor:pointer;font-family: poppins-semibold;font-size:25px">{{ item.title }}</span>
                </router-link>
                  </v-flex>
                   <v-flex xs12>
                <span class="text" style="font-family: poppins-regular">
                  {{ DateFormatted(item.createdAt) }}
                </span>
              </v-flex>
                  <v-flex xs12>
                <span
                  style="font-family: poppins-regular"
                  class="text"
                  v-html="item.text"
                >
                </span>
              </v-flex>
                </v-layout>
              </v-flex>

             
             
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      result: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    //      DateFormatted(params) {
    //   return params ? monent (params).format("DD-MM-Y,h:mm:ss a") : "";
    // },
    DateFormatted(params) {
      return params ? moment(params).format("DD-MM-Y") : "";
    },
    getData() {
      this.appLoading = true;
      console.log("yes");
      axios({
        method: "GET",
        url: "blog/getlist",
      })
        .then((response) => {
          if (response.data.status == true) this.result = response.data.data;
          this.appLoading = false;
        })
        .catch((err) => {
          console.log(err());
          this.ServerError = true;
        });
    },
  },
};
</script>
<style scoped>
.text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>